var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 84,
    viewBox: "0 0 120 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.213 50.2855H98.3575V43.9031H108.213V50.2855ZM108.213 34.6196C106.473 34.4262 100.483 34.2328 98.3575 34.2328V42.1625H108.213V34.6196ZM118.647 76.7821H115.362V37.5207C115.362 36.5537 113.237 35.7801 109.952 35.0065V76.7821H108.019V68.6591H98.1642V76.7821H96.2319V34.0394C87.1497 34.0394 77.6811 35.3933 76.715 37.1339V65.9514V67.8854C77.8744 67.8854 80 67.8854 80.7729 67.8854C83.4782 67.8854 84.6377 69.8195 84.6377 72.7206V81.4238C84.6377 82.1975 84.4444 82.9711 84.2512 83.7447H118.647C119.42 83.7447 120 83.1645 120 82.3909V77.9425C120 77.3623 119.42 76.7821 118.647 76.7821ZM108.213 60.3426H98.3575V66.725H108.213V60.3426ZM108.213 52.2196H98.3575V58.602H108.213V52.2196Z",
    fill: "#22883A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1594 73.6876V81.6172C81.1594 82.7777 80.1932 83.9381 78.8406 83.9381H2.31884C1.15942 83.9381 0 82.9711 0 81.6172V73.6876C0 72.5272 0.966184 71.3667 2.31884 71.3667H7.92271V6.18898C7.92271 2.70768 22.6087 0 40.5797 0C42.7053 0 44.8309 0 46.9565 0.193406V71.5601H50.4348V56.8613H64.3478V71.5601H67.8261V2.70768C71.3043 3.67471 73.2367 4.83514 73.2367 6.18898V71.5601H78.8406C80.1932 71.3667 81.1594 72.3337 81.1594 73.6876ZM64.3478 1.54725C61.4493 0.967029 54.2995 0.580217 50.4348 0.386812V11.2175H64.3478V1.54725ZM64.3478 14.6988H50.4348V25.1427H64.3478V14.6988ZM64.3478 28.8175H50.4348V39.2614H64.3478V28.8175ZM64.3478 42.7427H50.4348V53.1866H64.3478V42.7427Z",
    fill: "#22883A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 83.9381,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/inventory-icon.b62c0c6432698a019dc8772fcbf9efa8.svg";
export { ForwardRef as ReactComponent };